import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../../core/auth.service';
import { LoadingService } from '../../../../core/loading.service';
import { DialogService } from '../../../../core/dialog.service';
import { AlertService } from '../../../../core/alert.service';
import { UtilityService } from '../../../../core/utility.service';
import { TranslatorService } from '../../../../core/translator.service';
import { OptionsSource } from '../../../../core/core.models';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/app/shared/base/base.service';
import { BaseFormComponent } from 'src/app/shared/base/base-form.component';
import { Constants } from 'src/app/app.constants';
import { MeanOfDelivery, Type } from 'src/app/inside-layout/routes/means-of-delivery/means-of-delivery.models';
import { ValueLabel } from 'src/app/shared/base/base.models';
import { PointsOfSaleService } from '../../points-of-sale/points-of-sale.service';
import { PointOfSale } from '../../points-of-sale/points-of-sale.models';

@Component({
  selector: 'app-means-of-delivery-form',
  templateUrl: './means-of-delivery-form.component.html',
  styleUrls: ['./means-of-delivery-form.component.scss']
})
export class MeansOfDeliveryFormComponent extends BaseFormComponent implements OnInit {
  public minDateFrom: Date = new Date();
  public types: ValueLabel[] = [];
  public pointsOfSale: OptionsSource;

  constructor(
    private pointsOfSaleService: PointsOfSaleService,
    public authService: AuthService,
    public loadingService: LoadingService,
    public translatorService: TranslatorService,
    public utilityService: UtilityService,
    protected activatedRoute: ActivatedRoute,
    protected baseService: BaseService,
    protected dialogService: DialogService,
    protected router: Router,
    protected alertService: AlertService) {
      super(authService, loadingService, translatorService, utilityService, activatedRoute, baseService, dialogService, router, alertService);
     }

     ngOnInit(): void {
      this.authorities.init('CD_CD', 'R_CD', 'U_CD', 'CD_CD');
      this.url = `${Constants.contextPath}/means-of-delivery`;
      this.prepareLookupData();
      this.prepareFormData(new MeanOfDelivery(), (response: MeanOfDelivery) => {
        if(response.pointOfSale) {
          let pointOfSale = <PointOfSale>response.pointOfSale;
          response.pointOfSale = pointOfSale.id;
        }
        response.breadcrumbsId = response.description;
        return response;
      });
    }

    prepareLookupData() {
      this.types = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(Type, true), 'value', 'label', 'ENUMS.DELIVERY_TYPES.');
      this.pointsOfSale = this.pointsOfSaleService.getPointsOfSaleOptions();
    }
}

